module.exports = __webpack_public_path__ + "25e835eb.svg";